import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconCancel from "@material-ui/icons/Cancel";
import React, { Component, Fragment } from "react";
import {
  Button,
  CREATE,
  crudGetMatching,
  fetchEnd,
  fetchStart,
  SaveButton,
  showNotification
} from "react-admin";
import { connect } from "react-redux";
import { change, isSubmitting, submit } from "redux-form";
import dataProvider from "../dataProvider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

class CancelBookingButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      showDialog: false,

      sendCustomerEmail: false
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.handleCustomerEmailOption = this.handleCustomerEmailOption.bind(this);
  }

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
  };

  handleCustomerEmailOption(e) {
    this.setState({
      sendCustomerEmail: e.target.checked
    });
  }

  handleSaveClick = () => {
    // This is needed because our modal action buttons are oustide the form
    let bookingID = this.props.data.id;
    const { fetchStart, fetchEnd, showNotification } = this.props;
    // Dispatch an action letting react-admin know a API call is ongoing
    fetchStart();
    dataProvider(CREATE, "actions/booking/adminCancel", {
      data: {
        bookingID,
        sendCustomerEmail: this.state.sendCustomerEmail
      }
    })
      .then(() => {
        this.setState({ showDialog: false });
        //hacky to see the effects
        window.location.reload();
      })
      .catch(error => {
        showNotification(error.message, "error");
      })
      .finally(() => {
        // Dispatch an action letting react-admin know a API call has ended
        fetchEnd();
      });
  };

  render() {
    const { showDialog } = this.state;
    const { isSubmitting } = this.props;
    return (
      <Fragment>
        <Button onClick={this.handleClick} label="Cancel booking"></Button>
        <Dialog fullWidth open={showDialog} onClose={this.handleCloseClick}>
          <DialogTitle>Cancel booking?</DialogTitle>
          <DialogContent>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.sendCustomerEmail}
                  onChange={this.handleCustomerEmailOption}
                  name="school"
                  color="primary"
                />
              }
              label="Send customer email?"
            />
          </DialogContent>
          <DialogActions>
            <SaveButton
              label="Yes,i am sure."
              saving={isSubmitting}
              handleSubmitWithRedirect={this.handleSaveClick}
            />
            <Button label="Cancel" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isSubmitting: isSubmitting("post-quick-create")(state)
});

const mapDispatchToProps = {
  change,
  crudGetMatching,
  fetchEnd,
  fetchStart,
  showNotification,
  submit
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CancelBookingButton);
